import axiosInstance from 'utils/axiosInstance';
import {} from '../types/softwareTypes';
import {
  Intervention,
  InterventionFilter,
  InterventionHistory,
  InterventionInfo,
  InterventionListResponse,
  UsersFilter,
} from '../types/interventionTypes';

export const getIntervention = async (filters: InterventionFilter) => {
  const { data } = await axiosInstance.post<
    ApiResponse<InterventionListResponse>
  >('api/intervention/List', filters);
  return data;
};

export const getInterventionUsers = async (info: UsersFilter) => {
  const { data } = await axiosInstance.post<
    ApiResponse<{ id: string; text: string }[]>
  >('api/intervention/GetUsers', info);
  return data;
};

export const createIntervention = async (intervention: FormData) => {
  const { data } = await axiosInstance.post<ApiResponse<Intervention>>(
    'api/intervention/Create',
    intervention,
  );
  return data;
};

export const editIntervention = async (intervention: FormData) => {
  const { data } = await axiosInstance.post<ApiResponse<Intervention>>(
    'api/intervention/Update',
    intervention,
  );
  return data;
};

export const getInterventionById = async (id: number) => {
  const { data } = await axiosInstance.get<ApiResponse<Intervention>>(
    `api/intervention/GetById/${id}`,
  );
  return data;
};

export const getInterventionHistory = async (id: number) => {
  const { data } = await axiosInstance.get<ApiResponse<InterventionHistory[]>>(
    `api/intervention/History/${id}`,
  );
  return data;
};

export const getAssignedIntervention = async (info: InterventionInfo) => {
  const { data } = await axiosInstance.post<
    ApiResponse<{ id: string; text: string }[]>
  >('api/intervention/GetUsers', info);
  return data;
};

export const closeIntervention = async (info: {
  id: number;
  resolut: boolean;
  description: string;
}) => {
  const { data } = await axiosInstance.post<ApiResponse<Intervention>>(
    'api/intervention/Close',
    info,
  );
  return data;
};

export const getInterventionStatusList = async () => {
  const { data } = await axiosInstance.get<ApiResponse<string[]>>(
    'api/intervention/statuslist',
  );
  return data;
};

export const addInterventionStep = async (info: {
  id: number;
  user_Id?: number;
  step?: string;
  description?: string;
}) => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    'api/intervention/AddStep',
    info,
  );
  return data;
};

export const deleteIntervention = async (id: number) => {
  const { data } = await axiosInstance.delete<ApiResponse<string[]>>(
    `api/intervention/delete/${id}`,
  );
  return data;
};

export const assignIntervention = async (info: {
  id: number;
  user_Id?: string;
  step?: string;
  description?: string;
  assign: boolean;
  allUsers: boolean;
}) => {
  const { data } = await axiosInstance.post<ApiResponse<Intervention>>(
    'api/intervention/AssignedTo',
    info,
  );
  return data;
};

export const deleteInterventionFile = async (id: number) => {
  const { data } = await axiosInstance.delete<ApiResponse<string[]>>(
    `api/intervention/deleteFile/${id}`,
  );
  return data;
};
